import { init } from '@makemydeal/dr-activities-dealership-picker';
import { APP_NAME } from './constants';
import { additionalSelectors } from './additionalSelectors';

export const configureDealershipPicker = () => {
    const { middlewareMgr } = init(APP_NAME, additionalSelectors);
    return middlewareMgr;
};
